import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { formatINR } from "@/data/products";

const StatCard = ({ label, value }) => (
  <div className="border border-[#EBE8E3] rounded-lg p-6 bg-white">
    <p className="text-[11px] tracking-[0.25em] uppercase text-[#5C5C5C] mb-2">{label}</p>
    <p className="font-serif-lux text-3xl">{value}</p>
  </div>
);

const Dashboard = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["admin-dashboard"],
    queryFn: async () => (await api.get("/admin/dashboard")).data,
  });

  if (isLoading || !data) return null;

  return (
    <div>
      <h1 className="font-serif-lux text-3xl mb-8">Dashboard</h1>

      <div className="grid md:grid-cols-4 gap-6 mb-10">
        <StatCard label="Total Revenue" value={formatINR(data.totalRevenue)} />
        <StatCard label="Total Orders" value={data.totalOrders} />
        <StatCard label="Customers" value={data.totalCustomers} />
        <StatCard label="Low Stock Items" value={data.lowStockProducts.length} />
      </div>

      <div className="grid md:grid-cols-2 gap-10">
        <div>
          <h2 className="text-sm font-medium mb-4">Orders by Status</h2>
          <div className="border border-[#EBE8E3] rounded-lg divide-y divide-[#EBE8E3] bg-white">
            {Object.entries(data.ordersByStatus).map(([status, count]) => (
              <div key={status} className="flex justify-between px-5 py-3 text-sm">
                <span className="capitalize">{status}</span>
                <span>{count}</span>
              </div>
            ))}
          </div>

          <h2 className="text-sm font-medium mb-4 mt-8">Low Stock</h2>
          <div className="border border-[#EBE8E3] rounded-lg divide-y divide-[#EBE8E3] bg-white">
            {data.lowStockProducts.length === 0 && <p className="px-5 py-3 text-sm text-[#5C5C5C]">Nothing low on stock.</p>}
            {data.lowStockProducts.map((p) => (
              <div key={p.slug} className="flex justify-between px-5 py-3 text-sm">
                <span>{p.name}</span>
                <span>{p.stock} left</span>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 className="text-sm font-medium mb-4">Recent Orders</h2>
          <div className="border border-[#EBE8E3] rounded-lg divide-y divide-[#EBE8E3] bg-white">
            {data.recentOrders.length === 0 && <p className="px-5 py-3 text-sm text-[#5C5C5C]">No orders yet.</p>}
            {data.recentOrders.map((o) => (
              <Link to={`/admin/orders/${o._id}`} key={o._id} className="flex justify-between px-5 py-3 text-sm hover:bg-[#F9F8F6]">
                <span>{o.orderNumber} — {o.user?.name}</span>
                <span>{formatINR(o.total)}</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
